<div [agprLoading]="loading" #chart class="agpr-coverageOverTime"></div>